<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">公司名称</span>
            <el-input
              v-model="listQuery.name"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <!-- <div class="filter-box">
            <span class="label">公司座机</span>
            <el-input
              v-model="listQuery.phone"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div> -->
          <div class="filter-box">
            <span class="label">联系人</span>
            <el-input
              v-model="listQuery.contactName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">手机</span>
            <el-input
              v-model="listQuery.contactPhone"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">客户级别</span>
            <el-select :filterable="true" v-model="listQuery.customerLevelId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <template v-if="customerLevelOption.length">
                <el-option
                  v-for="item in customerLevelOption"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </template>
              <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">客户来源</span>
            <el-select :filterable="true" v-model="listQuery.customerSourceId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <template v-if="customerSourceOption.length">
                <el-option
                  v-for="item in customerSourceOption"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </template>
              <el-option v-else :value="-1" disabled>暂无数据</el-option>
            </el-select>
          </div>
          <template v-if="fromType === 'ALL'">
            <div class="filter-box">
              <span class="label">付款周期</span>
              <el-select :filterable="true" v-model="listQuery.paymentCycleId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
                <template v-if="paymentCycleOption.length">
                  <el-option
                    v-for="item in paymentCycleOption"
                    :key="item.id"
                    :label="item.mark"
                    :value="item.id"
                  />
                </template>
                <el-option v-else :value="-1" disabled>暂无数据</el-option>
              </el-select>
            </div>
            <div class="filter-box" v-show="showSalesManFilter" >
              <span class="label">业务代表</span>
              <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
                <template v-if="salesManOption.length">
                  <el-option
                    v-for="item in salesManOption"
                    :key="item.id"
                    :label="item.mark"
                    :value="item.id"
                  />
                </template>
                <el-option v-else :value="-1" disabled>暂无数据</el-option>
              </el-select>
            </div>
            <div class="filter-box">
              <span class="label">省市县</span>
              <el-cascader :filterable="true" v-model="listQuery.address" :props="provincesLoad" :clearable="true" placeholder="" @change="handleFilter">
                <template #default="{ node, data }">
                  <span style="display:none">{{ node.isLeaf }}</span>
                  <span>{{ data.name }}</span>
                </template>
              </el-cascader>
            </div>
            <div class="filter-box">
              <span class="label">审批状态</span>
              <el-select :filterable="true" v-model="listQuery.changeStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
                <template v-if="ReviewStatusOption.length">
                  <el-option
                    v-for="item in ReviewStatusOption"
                    :key="item.id"
                    :label="item.mark"
                    :value="item.id"
                  />
                </template>
                <el-option v-else :value="-1" disabled>暂无数据</el-option>
              </el-select>
            </div>
          </template>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
            <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="el => { if (el) tableListRef[0] = el }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :isShowPagination="false"
              :handleDefaultWidth="120"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :canRefresh="false"
              :canChangeColumn="false"
              :canCommand="canCommand"
              style="height:calc(100% - 0px);overflow:hidden;"
              @command-change="handleCommand"
              @row-click="handleRowClick"
            >
              <template v-slot:name="scope">
                <span :class="scope.row.changeStatus === 2 ? 'redStatusStyle' : scope.row.changeStatus === 1 ? 'yellowStatusStyle' : ''" class="statusStyle" >
                  <template v-if="scope.row.changeStatus && scope.row.changeStatus !== 3">
                    <i class="iconfont icon-tubiao-40" ></i>
                    <span class="status" >{{ReviewStatusOption.find(k => k.id === scope.row.changeStatus) ? ReviewStatusOption.find(k => k.id === scope.row.changeStatus).mark : ''}} </span>
                  </template>
                  <span>{{scope.row.name}}</span>
                </span>
              </template>

              <template v-slot:operation-action="scope">
                <CommandRender
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li v-for="item in tabList" :key="item.id" :class="{ active: activeTab === item.id }" @click="handleTabClick(item)">{{item.name}}</li>
                </ul>
                <!-- <div class="fr rigth-opt">
                  <span class="svg-icon cursor mr-10"  @click="handleTabCommand('refresh')">
                    <i class="icon-tubiao-27 iconfont"/>
                  </span>
                  <span class="svg-icon cursor" @click="handleTabCommand('column')" >
                    <i class="icon-tubiao-28 iconfont"/>
                  </span>
                </div> -->
              </div>
              <ContactList v-if="activeTab === 1" ref="ContactList" :id="activeId" :canCommand="contactCanCommand"/>
              <InvoiceInfoList v-if="activeTab === 2" ref="InvoiceInfoList" :id="activeId" :canCommand="invoiceCanCommand"/>
              <TraceInfo v-if="activeTab === 3" ref="TraceInfo" :id="activeId" :api="'customerCompany'"/>
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :handleResolveTempData="handleResolveTempData"
      :api="'customerCompany'"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <el-dialog
      v-model="remindedVisible"
      title="设置超期提醒"
      width="40%"
    >
      <div v-if="remindedVisible">
        <el-checkbox label="超期未合作提醒" v-model="remindedCheckList.overdueWithoutBusinessNoticeSwitch" />
        <el-checkbox label="超期未订单提醒" v-model="remindedCheckList.overdueWithoutOrderNoticeSwitch" />
        <el-checkbox label="超期未联系提醒" v-model="remindedCheckList.overdueWithoutContactNoticeSwitch" />
        <el-checkbox label="超期未收款提醒" v-model="remindedCheckList.overdueWithoutPaymentNoticeSwitch" />
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="remindedVisible = false" type="danger">取消</el-button>
          <el-button type="primary" @click="handleSetReminded">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="fpVisible"
      title="分配业务员"
      width="40%"
    >
      <div v-if="fpVisible">
        <div class="warming-fp">提示：如果没有选择任何业务员，该客户公司将不属于任何一个业务员</div>
        <el-select :filterable="true" v-model="salesManId" class="filter-item" placeholder="输入关键字搜索" clearable>
          <template v-if="salesManOption.length">
            <el-option
              v-for="item in salesManOption"
              :key="item.id"
              :label="item.mark"
              :value="item.id"
            />
          </template>
          <el-option v-else :value="-1" disabled>暂无数据</el-option>
        </el-select>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="fpVisible = false" type="danger">取消</el-button>
          <el-button type="primary" @click="handleSetFp">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="yejiVisible"
      title="设置业绩类型"
      width="40%"
    >
      <div v-if="yejiVisible">
        <el-radio-group v-model="achieveType">
          <el-radio :label="item.id" v-for="item in yejiOption" :key="item.id">{{item.mark}}</el-radio>
        </el-radio-group>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="yejiVisible = false;achieveType = ''" type="danger">取消</el-button>
          <el-button type="primary" @click="handleSetYeji">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-button type="primary" circle @click="handleSubMenuCollapse" class="subMenuCollapseBtn" v-if="!dialogFormVisible"> {{isSubMenuCollapse ? '展开' : '收起'}}</el-button>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { useStore } from '@/store'
import { defineComponent, reactive, toRefs, onMounted, ref, computed, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getCompanyDetailById, deleteCompanyById, getCompanyList, noticeSetting, changeSalesMan, setAchieve } from '@/apis/CustomerCompany'

import { getDropdown } from '@/apis/Dictionary'
import { getPageList } from '@/apis/Form'
import { getDropdownByType } from '@/apis/tool'
import { salesmanUser } from '@/apis/user'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import ContactList from '../contact/Index.vue'
import InvoiceInfoList from '../invoiceInfo/Index.vue'
import TraceInfo from '@/components/traceInfo/Index.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'
import mixin from '@/mixins/index'
import CommandRender from '@/components/common/CommandRender.vue'
import { getSysAreaListByNo } from '@/apis/sysArea'
import { pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'Customerinfo',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    ContactList,
    InvoiceInfoList,
    TraceInfo,
    CommandRender
  },
  props: {
    fromType: { type: String, required: false, default: 'ALL' },
    canCommand: { type: Boolean, required: false, default: true },
    contactCanCommand: { type: Boolean, required: false, default: true },
    invoiceCanCommand: { type: Boolean, required: false, default: true }
  },
  setup(props) {
    const { t } = useI18n()
    const tableListRef = ref([])
    const store = useStore()
    const userId = store.state.user.userId
    const ContactList = ref(null)
    const InvoiceInfoList = ref(null)
    const TraceInfo = ref(null)
    const TableList = ref(null)

    const dataMap = reactive({
      TableName: TableName.TABLE_CUSTOMERCOMPANY,
      permissionName: permissionName.CUSTOMER_INFO,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField,
      fromType: props.fromType,
      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        phone: undefined,
        contactName: undefined,
        contactPhone: undefined,
        customerLevelId: undefined,
        customerSourceId: undefined,
        paymentCycleId: undefined,
        salesManId: undefined,
        changeStatus: undefined,
        address: [],
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,
      tabList: [
        { name: '联系人', id: 1 },
        { name: '开票资料', id: 2 },
        { name: '跟踪信息', id: 3 }
      ],
      activeTab: 1,

      customerLevelOption: [],
      customerSourceOption: [],
      paymentCycleOption: [],
      salesManOption: [],
      ReviewStatusOption: [],
      remindedVisible: false,
      remindedCheckList: {
        overdueWithoutBusinessNoticeSwitch: 0,
        overdueWithoutOrderNoticeSwitch: 0,
        overdueWithoutContactNoticeSwitch: 0,
        overdueWithoutPaymentNoticeSwitch: 0
      },
      salesManId: '',
      fpVisible: false,
      newHpx: 0,
      yejiVisible: false,
      achieveType: '',
      yejiOption: [],
      btnList: [],

      async handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'fp':// 分配
            dataMap.salesManId = val.salesManId
            dataMap.activeId = val.id
            dataMap.fpVisible = true
            break
          case 'remind':// 设置超期提醒
            dataMap.activeId = val.id
            dataMap.remindedVisible = true
            break
          case 'yeji':// 设置业绩类型
            dataMap.activeId = val.id
            dataMap.yejiOption = await getDropdownByType('AchieveType') || []
            // eslint-disable-next-line no-case-declarations
            const result = await getCompanyDetailById(dataMap.activeId)
            dataMap.achieveType = result.achieveType
            dataMap.yejiVisible = true
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      calcHeight() {
        return 'calc(100% - 50px)'
      },
      handleTabCommand(command: string) {
        if (this.activeTab === 1) {
          if (ContactList.value && ContactList.value) {
            ;(ContactList.value as any).handleCommand(command)
          }
        } else if (this.activeTab === 2) {
          if (InvoiceInfoList.value && InvoiceInfoList.value) {
            ;(InvoiceInfoList.value as any).handleCommand(command)
          }
        } else if (this.activeTab === 3) {
          if (TraceInfo.value && TraceInfo.value) {
            ;(TraceInfo.value as any).handleCommand(command)
          }
        }
      },
      getList() {
        dataMap.listLoading = true
        const _address = dataMap.listQuery.address ? dataMap.listQuery.address.join('-') : null
        getCompanyList({ ...dataMap.listQuery, type: props.fromType, address: _address }).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          phone: undefined,
          contactName: undefined,
          contactPhone: undefined,
          customerLevelId: undefined,
          customerSourceId: undefined,
          paymentCycleId: undefined,
          salesManId: undefined,
          changeStatus: undefined,
          address: [],
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        const temp = cloneDeep(dataMap.initFormData)
        dataMap.fromFieldData = temp.map(item => {
          if (item.title === '开票信息') {
            item.formList = []
          }
          return item
        })
        console.log(dataMap.fromFieldData, ' dataMap.fromFieldData')
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getCompanyDetailById(row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                if (res[field.fieldKey] !== undefined) {
                  field.value = res[field.fieldKey]
                }
                // 若为单选组件但值为空数组，转为 null
                if (!field.config?.multiple && Array.isArray(field.value) && field.value.length === 0) {
                  field.value = null
                }
                switch (field.fieldKey) {
                  case 'address':
                    field.value = res.address ? res.address.split('-') : ''
                    break
                }
              })
            }
          })
          dataMap.fromFieldData = dataMap.fromFieldData.filter((k: any) => k.type === 1)
          dataMap.dialogFormVisible = true
        })
      },
      handleResolveTempData(tempModel: any) {
        const { address } = tempModel
        let contacts = tempModel.contacts
        if (contacts) {
          contacts.map((k: any) => {
            k.address = address ? address.join('-') : ''
            return {
              ...k
            }
          })
        } else {
          contacts = []
        }
        tempModel.address = address ? address.join('-') : ''

        // 规范化单选 ID 字段：若为空数组则转换为 null
        const idFields = ['customerLevelId', 'customerSourceId', 'paymentCycleId', 'industryId', 'companyTypeId', 'salesManId']
        idFields.forEach(k => {
          if (Array.isArray(tempModel[k]) && tempModel[k].length === 0) {
            tempModel[k] = null
          }
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteCompanyById(row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      getDropdownByType() {
        getDropdownByType('ReviewStatus').then((res: any) => {
          dataMap.ReviewStatusOption = res
        })
      },
      loadSalesMan() {
        salesmanUser().then((res: any) => {
          dataMap.salesManOption = res
        })
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 2 && column.url) {
            getPageList(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          } else if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleSetFp() {
        changeSalesMan(dataMap.activeId, { salesManId: dataMap.salesManId }).then(() => {
          dataMap.getList()
          dataMap.fpVisible = false
        }).catch(() => {
          dataMap.fpVisible = false
        })
      },
      handleSetYeji() {
        setAchieve(dataMap.activeId, { achieveType: dataMap.achieveType }).then(() => {
          dataMap.getList()
          dataMap.achieveType = ''
          dataMap.yejiVisible = false
        }).catch(() => {
          dataMap.yejiVisible = false
        })
      },
      handleSetReminded() {
        const { overdueWithoutBusinessNoticeSwitch, overdueWithoutOrderNoticeSwitch, overdueWithoutContactNoticeSwitch, overdueWithoutPaymentNoticeSwitch } = dataMap.remindedCheckList
        dataMap.remindedCheckList = {
          overdueWithoutBusinessNoticeSwitch: Number(overdueWithoutBusinessNoticeSwitch),
          overdueWithoutOrderNoticeSwitch: Number(overdueWithoutOrderNoticeSwitch),
          overdueWithoutContactNoticeSwitch: Number(overdueWithoutContactNoticeSwitch),
          overdueWithoutPaymentNoticeSwitch: Number(overdueWithoutPaymentNoticeSwitch)
        }

        noticeSetting(dataMap.activeId, dataMap.remindedCheckList).then(() => {
          dataMap.getList()
          dataMap.remindedVisible = false
        }).catch(() => {
          dataMap.remindedVisible = false
        })
      },
      provincesLoad: {
        lazy: true,
        label: 'name',
        value: 'name',
        checkStrictly: true,
        lazyLoad(node: any, resolve: any) {
          const { level } = node
          const _no = level === 0 ? level : node.data.no
          getSysAreaListByNo(_no).then((res: any) => {
            const nodes = res.map((k: any) => {
              return {
                ...k,
                leaf: !k.hasChildren
              }
            })
            resolve(nodes)
          })
        }
      }
    })
    const showSalesManFilter = computed(() => {
      if (!dataMap.salesManOption.length) {
        return false
      }
      // let ids = dataMap.salesManOption.map(k => k.id)
      // ids = Array.from(new Set(ids))
      // if (ids.length === 1 && ids[0] === userId) {
      //   return false
      // }
      if (dataMap.salesManOption.length === 1 && dataMap.salesManOption[0].id === userId) {
        return false
      }
      return true
    })
    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./customer/customerInfo',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    onMounted(async() => {
      mixinData.initHeight()

      await dataMap.loadTableSelectOption()
      dataMap.getList()
      dataMap.loadSalesMan()
      dataMap.loadDropdownList('customerLevel')
      dataMap.loadDropdownList('customerSource')
      dataMap.loadDropdownList('paymentCycle')
      dataMap.getDropdownByType()
      dataMap.btnList = [
        {
          pkey: `${dataMap.permissionName}_EDIT`,
          name: '编辑',
          command: 'edit'
        }, {
          pkey: `${dataMap.permissionName}_REMIND`,
          name: '设置超期提醒',
          command: 'remind'
        }, {
          pkey: `${dataMap.permissionName}_YJ`,
          name: '设置业绩类型',
          command: 'yeji'
        }, {
          pkey: `${dataMap.permissionName}_FP`,
          name: '分配',
          command: 'fp'
        },
        {
          pkey: `${dataMap.permissionName}_DELETE`,
          name: '删除',
          type: 'danger',
          command: 'delete'
        }
      ]
    })
    return { ContactList, InvoiceInfoList, TraceInfo, TableList, t, ...toRefs(dataMap), userId, showSalesManFilter, ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse, tableListRef }
  }
})
</script>
<style  lang="scss">
.grid-layout-container {
.vue-grid-item {
  background:#666 ;
}
}
</style>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
.warming-fp{
  border-radius: 4px;
  border: 1px solid $red;
  color:$red;
  padding: 8px;
  margin-bottom: 20px;
}
</style>
